import { useFlickity } from '@/components/hooks/useFlickity'
import { BaseResults } from 'libs/searchspring/components/recommendations/BaseResults'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useState } from 'preact/hooks'

export function CarouselResults({
  className,
  wrapperClassName = '',
  options = { pageDots: true, cellAlign: 'left' },
  productCardOptions
}) {
  const renderWithFlickity = (items) => {
    const { results } = useSearchspringContext()
    const [node, setNode] = useState()
    const { SliderPortal } = useFlickity(node, options, [results])

    return (
      <div ref={setNode} className="flex w-full pb-2 flickity-dots-inside flickity-element">
        <SliderPortal>
          {items}
        </SliderPortal>
      </div>
    )
  }

  return (
    <BaseResults
      className={className}
      wrapperClassName={wrapperClassName}
      productCardOptions={productCardOptions}
      renderWrapper={renderWithFlickity}
    />
  )
}
